import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { CreateActionContext } from "./CreateActionContext";

function useStore(modelConfig: any) {
  const { element, setBackendFormErrors, setLoading } = useContext(CreateActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    setLoading(true);
    store(modelConfig.endpoint, element)
      .then((response: any) => {        
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      })
      .finally(() => {
        setLoading(false);
      });
  };
}

export default useStore;
